import React from 'react';
import {
  Modal,
  Alert,
} from 'react-bootstrap';

import Button from 'components/DesignSystem/Button';
import './index.scss';
import useEnsembleDownload from 'hooks/Meteorology/Weather/Similarity/useEnsebleDownload';

interface EnsembleModalProps {
  show?: boolean;
  onHide?: () => void;
  ensembleData?: {
    nome: string;
    variavel: string;
    mes: number;
    anos: number[];
    base64_data?: string;
    url?: string;
  } | null;
}

const MESES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

const VARIAVEIS_LABELS: Record<string, string> = {
  prec: 'Precipitação',
  'nino3.4': 'NINO 3.4',
  iod: 'Dipolo do Oceano Índico',
  tna: 'Atlântico Tropical Norte',
  tsa: 'Atlântico Tropical Sul',
  tad: 'Dipolo Tropical do Atlântico',
  sad: 'Dipolo do Atlântico Sul',
  amo: 'Oscilação Multidecadal do Atlântico',
  sac: 'Complexo de Convecção da América do Sul',
  pdo: 'Oscilação Decadal do Pacífico',
  aao: 'Oscilação Antártica',
};

export default function EnsembleModal({
  show = false,
  onHide = () => {},
  ensembleData = null,
}: EnsembleModalProps) {
  const { downloadEnsemble, downloadLoading } = useEnsembleDownload();

  const handleDownload = () => downloadEnsemble(ensembleData);

  if (!ensembleData) {
    return null;
  }

  const formatVariavel = (variavel: string): string => (
    VARIAVEIS_LABELS[variavel?.toLowerCase()] || variavel
  );

  const anosArray = Array.isArray(ensembleData.anos) ? ensembleData.anos : [];
  const anosOrdenados = [...anosArray].sort((a, b) => a - b);
  const mesFormatado = MESES[ensembleData.mes - 1] || `mês ${ensembleData.mes}`;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      className="ensemble-dialog-modal"
    >
      <Modal.Header closeButton className="confirmation-dialog-modal-header">
        <Modal.Title className="ms-4">Resultado do Ensemble</Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4 pt-0">
        <div className="ensemble-dialog-content">

          <div className="d-flex align-items-center justify-content-between mb-3">

            <div className="ensemble-parameters text-center flex-grow-1">
              <span className="parameter-item mx-3">
                <strong>Variável:</strong>
                {' '}
                {formatVariavel(ensembleData.variavel)}
              </span>

              <span className="parameter-item mx-3">
                <strong>Mês:</strong>
                {' '}
                {mesFormatado}
              </span>

              <span className="parameter-item mx-3">
                <strong>
                  Anos (
                  {anosOrdenados.length}
                  )
                  :
                </strong>
                {' '}
                {anosOrdenados.join(', ')}
              </span>
            </div>

            {(ensembleData.base64_data || ensembleData.url) && (
              <Button
                type="primary"
                onClick={handleDownload}
                icon="download"
                disabled={downloadLoading}
                className="ms-3"
              />
            )}
          </div>

          {(ensembleData.url || ensembleData.base64_data) ? (
            <div className="ensemble-content">
              <div className="ensemble-image-container">
                <img
                  src={
                    ensembleData.url
                    || `data:image/png;base64,${ensembleData.base64_data}`
                  }
                  alt={`Mapa Ensemble - ${ensembleData.nome}`}
                  className="ensemble-image"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = '/mapa.png';
                  }}
                />
              </div>
            </div>
          ) : (
            <Alert variant="info" className="mt-3">
              <p className="mb-0">Nenhum mapa ensemble disponível para exibição.</p>
            </Alert>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
